import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { UserInfoService } from 'src/app/shared/services/user-info.service';
import { ReportSentSnackbarComponent } from 'src/app/micro-components/report-sent-snackbar/report-sent-snackbar.component';

// Single source for the "report sent / failed" feedback shown after any report
// is triggered (query one-click + the report dialog's entity/portfolio/query
// sends). Keeps the copy and presentation in one place.
@Injectable({ providedIn: 'root' })
export class ReportFeedbackService {
  constructor(
    private snackBar: MatSnackBar,
    private userInfo: UserInfoService,
  ) {}

  reportSent(): void {
    this.snackBar.openFromComponent(ReportSentSnackbarComponent, {
      data: { email: this.userInfo.email },
      duration: 9000,
      panelClass: 'report-sent-snackbar',
    });
  }

  reportError(): void {
    this.snackBar.open(
      'Something went wrong, the report could not be sent.',
      'OK',
      { duration: 5000, panelClass: ['red-snackbar'] },
    );
  }
}
